<!-- Floating ReadSpeaker Toggle Button -->
<button class="rs-floating-btn" (click)="toggleRead()">
  <i class="fas fa-volume-up"></i>
</button>

<app-accessibility></app-accessibility>

<nav
  class="floating-social-links"
  *ngIf="socialLinks.length && !hideFloatingSocial"
  aria-label="Social media links">
  <a
    *ngFor="let link of socialLinks"
    class="floating-social-link"
    [href]="link.url"
    target="_blank"
    rel="noopener noreferrer"
    [attr.aria-label]="link.name"
    [title]="link.name">
    <i [class]="link.icon"></i>
  </a>
</nav>

<div id="contentToRead">
  <router-outlet></router-outlet>
</div>
